import type { ReactElement } from "react";
import { Box, Drawer, Typography, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button } from "@mui/material";
import Scrollbar from "src/components/scrollbar";
import useResponsive from "src/hooks/useResponsive";

export type ConfirmModalProps = {
  onAction: VoidFunction;
  title?: string;
  rows: any[];
  cols: string[];
  onClose: VoidFunction;
}

export const ConfirmDrawerModal = ({
  onAction,
  title,
  rows,
  cols,
  onClose
}: ConfirmModalProps): ReactElement => {
  const isDesktop = useResponsive('up', 'md');

  return (
    <Drawer
      anchor="right"
      open
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: isDesktop ? '500px' : '100%', // Если не десктоп, ширина будет 100%
          // Если хотите, чтобы на мобильных устройствах Drawer также был на всю высоту, можно добавить maxHeight: '100vh'
        }
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
      >
        <Typography variant="h6" component="div" sx={{ p: 2 }}>
          {title || 'Do you want to continue?'}
        </Typography>

        <Box flexGrow={1} overflow="hidden">
          <Scrollbar>
            <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
              <Table stickyHeader aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    {cols.map((colName, index) => (
                      <TableCell key={index}>{colName}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      {cols.map((colName, index) => (
                        <TableCell key={index}>{row[colName]}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Box>

        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid', borderColor: 'divider', mt: 'auto' }}>
          <Button color="inherit" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onAction} sx={{ ml: 1 }}>
            Continue
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};